import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  quote: string;
}
export function TestimonialCard({
  name,
  age,
  quote
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 flex flex-col" data-id="element-360">
      <div className="flex gap-1 mb-4" data-id="element-361">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-362" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow text-lg" data-id="element-363">"{quote}"</p>
      <div className="mt-auto border-t border-gray-100 pt-4" data-id="element-364">
        <p className="font-bold text-gray-900" data-id="element-365">
          — {name}, {age} años
        </p>
      </div>
    </div>;
}